import type { FaireProductEntity } from "../../entity_types/product";

export const p_yuxxqsddct: FaireProductEntity = {
  token: "p_yuxxqsddct",
  type: "product",
  name: "Refill - Clean Paws No-Rinse Foaming Cleanser",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/702dd51f662d6534d400dc38cdd4669949b9a443133778b511698cf82a61a63d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/709e5d9cc046245b9cf722992474907c6191717c92ba989b42644d704eadbe9e.jpeg",
    "https://cdn.faire.com/fastly/d335e812926b1fa24b210432dc176c7afc4aa1c476c4f3c213d3e67c28afefce.jpeg",
    "https://cdn.faire.com/fastly/06175f9b782d88e152d8b43c38963c206cb546960f0dfbe606f10dd3e38e75b4.jpeg"
  ],
  priceDollars: 16,
  description: "Now you can get double of your favourite Dandylion Clean Paws no-rinse cleaner, available in 300mL refills. Unscrew your original Clean Paws foaming bottle, pour in some extra and save the rest for later!\n\nPlant-based ingredients, such as aloe juice, pomegranate juice, broccoli seed oil and grape seed oil, providing soothing, nourishing, and anti-microbial benefits to irritated, itchy or dry paws. Free from potentially irritating ingredients such as: harsh sulfates, artificial fragrances & dyes, drying SD alcohol, and essential oils.\n\n10 fl oz / 300 mL",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:39.369Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
